export const BUILDER_DIVIDER_NAMES = {
    WaxingCostPerYear: 'WaxingCostPerYear',
    UnlimitedPackage: 'UnlimitedPackage',
    UnlimitedPackage2: 'UnlimitedPackage2',
    ReasonsLHRVimeo: 'Reasons LHR Vimeo',
    AffordablePlansDivider: 'ResultsDivider',
    MilanCost: 'MilanCost',
    RatingsDivider: 'RatingsDivider',
    LipsOrUnderArmsDivider: 'LipsOrUnderArmsDivider',
    RatingsAndLipsOrUnderarmDivider: 'RatingsAndLipsOrUnderarmDivider',
    HeroWithImageAndLinkOnly: 'HeroWithImageAndLinkOnly',
    DynamicHero: 'DynamicHero',
    DynamicHeroV2: 'DynamicHeroV2',
    LandingPageHero: 'LandingPageHero',
    WhyMilanLHRIsIdeal: 'Why Milan LHR is Ideal',
    SectionDivider: 'SectionDivider',
    ShavingAndWaxingCalc: 'ShavingAndWaxingCalc',
    LHRBenefits: 'LHR Benefits',
    LocationsBanner: 'LocationsBanner',
    ScrollingBanner: 'ScrollingBanner',
    WhatCustomersSay: 'WhatCustomersSay',
    CreditApproval: 'CreditApproval',
    HowLHRWorks: 'How LHR Works',
    RichTextContent: 'RichTextContent',
    PopularBlogs: 'PopularBlogs',
    AuthorHero: 'Author Hero',
    AboutMilanSection: 'AboutMilanSection',
    AboutAuthor: 'AboutAuthor',
    PullQuote: 'PullQuote',
    BlogPostHero: 'BlogPostHero',
    ConsultationSection: 'ConsultationSection',
    SectionWithImage: 'SectionWithImage',
    BlogSection: 'BlogSection',
    BlogLayout: 'BlogLayout',
    BlogTextSection: 'BlogTextSection',
    BlogHeroCarousel: 'BlogHeroCarousel',
};

export const BUILDER_BLOG_AUTHOR_COMPONENTS_NAMES = {
    AuthorHero: 'Author Hero',
    AboutMilanSection: 'AboutMilanSection',
    AboutAuthor: 'AboutAuthor',
    PullQuote: 'PullQuote',
};
export const BUILDER_BLOG_COMPONENTS_NAMES = {
    AuthorHero: 'Author Hero',
    AboutMilanSection: 'AboutMilanSection',
    AboutAuthor: 'AboutAuthor',
    PullQuote: 'PullQuote',
    BlogPostHero: 'BlogPostHero',
    ConsultationSection: 'ConsultationSection',
    SectionWithImage: 'SectionWithImage',
    BlogSection: 'BlogSection',
    BlogLayout: 'BlogLayout',
    BlogTextSection: 'BlogTextSection',
    BlogFAQs: 'BlogFAQs',
    BlogHeroCarousel: 'BlogHeroCarousel',
    OurLatestBlogs: 'OurLatestBlogs',
};

export const BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES = {
    S1Hero: 'S1Hero',
    S2Icons: 'S2Icons',
    S3How: 'S3How',
    S4WhyChoose: 'S4WhyChoose',
    S5BeforeAfter: 'S5BeforeAfter',
    S6FAQs: 'S6FAQs',
    S7SubCategories: 'S7SubCategories',
    S8MixedMedia: 'S8MixedMedia',
    S9PressRelease: 'S9PressRelease',
    S10PressReleasePost: 'S10PressReleasePost',
    S11Awards: 'S11Awards',
    S12Reviews: 'S12Reviews',
    S13LHR: 'S13LHR',
    S14WhatToExpect: 'S14WhatToExpect',
    S15TwoSections: 'S15TwoSections',
    S16BackgroundImage: 'S16BackgroundImage',
    BuilderTestComponent: 'BuilderTestComponent',
    S17ToggleTabs: 'S17ToggleTabs',
    S18Video: 'S18Video',
    S19Timeline: 'S19Timeline',
    S20Choices: 'S20Choices',
    S31StateHero: 'S31StateHero',
    S32MapView: 'S32MapView',
    S33CondensedSpecial: 'S33CondensedSpecial',
    S34Dropdowns: 'S34Dropdowns',
    S35ClinicInfo: 'S35ClinicInfo',
    S36Staff: 'S36Staff',
    S37ReviewsOverall: 'S37ReviewsOverall',
    S37ReviewsCityOverall: 'S37ReviewsCityOverall',
    S38NearbyLocations: 'S38NearbyLocations',
    S39AdBanner: 'S39AdBanner',
    S40Breadcrumbs: 'S40Breadcrumbs',
};

export const BUILDER_HERO_COMPONENTS_NAMES = {
    BrandPartnerHero: 'BrandPartnerHero',
};
